import React from 'react';
import { Container, Row, Col, Card, ListGroup, Image } from 'react-bootstrap';
import './AboutUsPage.css'; // Import custom CSS for styling
import { ROUTES } from '../../config/routingUrl';
import { Link } from 'react-router-dom';
import SectionAboutBarner from './design/SectionAboutBarner';
import SectionAboutBlog from './design/SectionAboutBlog';
import SectionAboutServices from './design/SectionAboutServices';
import SectionAboutFaq from './design/SectionAboutFaq';

const AboutUsPage = () => {


    const propertyUrl = "aboutpropriete.jpg";
    const vehicleImgUrl = "images/gallery/pic7.jpg";


    const statifaction1 = "statifaction.jpg";
    const statifaction2 = "resavation-illustration.png";
    const statifaction3 = "support.png";
    const statifaction4 = "process.png";
    const statifaction5 = "offres.png";
    const statifaction6 = "security.png";



    return (
        <div style={{ overflow: "hidden" }}>

            <SectionAboutBarner />

            {/*Section pour blog  */}
            <SectionAboutBlog />

            {/*Section pour le services */}
            <SectionAboutServices />

            {/*Section pour le questionaire */}
            <SectionAboutFaq />

        </div>
    );
};

export default AboutUsPage;


